import React, { Component } from 'react';

import {
    Link
} from "react-router-dom";
import PatientMenu from './includes/PatientMenu';
import PatientPageHeader from './includes/PatientPageHeader';
import { _logOut, _getLoginStatus, _showOverlay, _hideOverlay, FILE_URL, _getLocalLanguage, _setLocationCookie, _getLocationCookie } from './includes/Constants';
import withNavigateHook from './includes/withNavigateHook';
import { _getAllDoctor } from './api/Patient';
import Toast from './includes/Toast';
import Loader from './includes/Loader';
import { lang_en } from './includes/language/en';
import { lang_hi } from './includes/language/hi';
import { _getCities } from './api/Common';
const language = _getLocalLanguage();


class PatientLabReports extends Component {
    /**
     * 
     * @param {*} props 
     */
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            list: [],
            message: '',
            type: '',
            visibility: 'hide',
            loader: "hide",
            text_language: language.lang == 'en' ? lang_en : lang_hi,
          
        }

    }


    /**
    * 
    * @returns 
    */
    componentDidMount = async () => {
        let res = await _getLoginStatus();
        // console.log(res.status);
        if (res['status'] == true) {
            let location = await _getCities();
            await this.setState({
                user: res.data,
                location_list: location.data.result
            });
            if (res['data']['user_type'] == 'Patient') {
                // setTimeout(async() => {
               // }, 1000);

            } else {
                this.props.navigation('/home');
            }

        } else {
            this.props.navigation('/home');
        }

    }

   
  
    /**
     * 
     * @returns 
     */
    /**
           * 
           */
      _getBookingList = () => {
          let total_counter = 0;
  
          if (Object.keys(this.state.list).length > 0) {
  
              return (
                  <ul className="">
                      <li className={"active"} key={"list-0"}>
                          {/* <div className="collapsible-header">
                                                <h6>{Object.keys(this.state.list)[index]}</h6>
                                          </div> */}
                          <React.Fragment key={"collapsible-body-0"}>
                              {
                                  Object.values(this.state.list).map((value1, index1) => {
  
                                      total_counter = total_counter + 1;
                                      return (
                                          <div className="#ffffff white lighten-5 z-depth-5 mb-10">
                                              <div key={"row-" + index1} className="row p-15">
                                                  <div className="col s12">
                                                      <span className="black-text">
                                                          <div className="info-row">
                                                              <p className="info-item"><b>Sr. No :</b>&nbsp;&nbsp;&nbsp;{total_counter}</p>
                                                              <p className="info-item"><b>Name :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.name}</p>
                                                          </div>
                                                          <div className="info-row">
                                                              <p className="info-item"><b>Age :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.age}&nbsp;years</p>
                                                              <p className="info-item"><b>Contact :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.phone_number}</p>
                                                          </div>
                                                          <div className="info-row">
                                                              <p className="info-item"><b>Status :</b>&nbsp;&nbsp;&nbsp;{value1.status}</p>
                                                          </div>
                                                          <hr />
  
                                                          {
                                                              Object.keys(value1.lab_test).length > 0 ?
                                                                  Object.values(value1.lab_test).map((value2, index2) => {
                                                                      return (
                                                                          <React.Fragment>
                                                                              <div className="info-row">
                                                                                  <p className="info-item"><b>Name :</b>&nbsp;&nbsp;&nbsp;{value2.test_code}</p>
                                                                                  <p className="info-item">
                                                                                      <b>Status :</b>
                                                                                  </p>
                                                                                  <p className="info-item">
                                                                                      {value2.status}
  
                                                                                  </p>
  
                                                                              </div>
                                                                              <div className="info-row">
                                                                                  <p className="info-item detailBtn"><b>Test Report :</b>&nbsp;&nbsp;&nbsp;
  
                                                                                      <a href={"https://oparchee.com/server/files/" + value2.report} className="center-align" target='_blank' download={'downlaod'}>Download {value2.test_code} report </a>
                                                                                  </p>
                                                                                  {/* <p className="info-item"><b>Tests:</b>&nbsp;&nbsp;&nbsp;{Object.keys(value1.lab_test).length === 0 ? 'Pending' : 'Added'}</p> */}
                                                                              </div>
  
  
  
  
  
  
  
                                                                          </React.Fragment>
                                                                      )
  
                                                                  })
                                                                  :
                                                                  ''
                                                          }
                                                          <hr />
  
                                                      </span>
                                                  </div>
                                              </div>
                                          </div>
                                      )
                                  })
                              }
                          </React.Fragment>
                      </li>
                  </ul>
              )
  
          } else {
              return (
  
                  <div className="col s12 center-align mt-20">
                      <img src="images/not-found.gif" alt="" className="circle responsive-img" />
  
                  </div>
  
              )
          }
  
      }
 



    render() {
        return (
            <React.Fragment>
            <Loader visibility={this.state.loader} />
                <PatientPageHeader />
                <main role="main">

                    <section id="dashboard-page" className="oparcheecommonCode">

                        <div className="dashboardContent">

                            <div className="container">
                                <div className="row">
                                    <div className="col s12 mt-10">
                                        <div className="strip">

                                            <div className="row pt-20">

                                                <div className="col s3 left-align">


                                                </div>

                                                <div className="col s6 center-align">

                                                    <div className="bookingTxt"><h3>
                                                        <span>{this.state.text_language[0].lab_text} {this.state.text_language[0].history_text}</span></h3>
                                                    </div>
                                                </div>
                                                <div className="col s3 right-align">


                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                    <div className="col s12">
                                        {this._getBookingList()}
                                    </div>

                                </div>

                            </div>

                        </div>

                    </section>

                </main>
                <PatientMenu />
                {
                    this.state.visibility == 'show'
                        ?
                        <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
                        :
                        ''
                }
                {/* <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} /> */}
            </React.Fragment>
        );
    }
}

export default withNavigateHook(PatientLabReports);
